import { useSearchParams } from 'react-router-dom';
import { RaffleFanPreview } from '@/engagements/raffle/fan/RaffleFanPreview';
import { parseRaffleFanPreviewState } from '@/engagements/raffle/fan/raffleFanPreviewStates';

export default function RaffleFanPreviewPage() {
  const [params] = useSearchParams();
  return (
    <RaffleFanPreview state={parseRaffleFanPreviewState(params.get('state'))} />
  );
}
